import React, {useEffect, useState} from 'react';
import {Button, Input, Modal, useToast} from 'uikit';
import WarningIcon from "@/assets/images/icons/16/warning.svg";
import styles from '../Confirm/Confirm.module.scss';
import {FormFields} from "@/utils/FormFields/FormFields";
import {RenameSchema} from "@/views/Admin/Events/Event/Promocodes/Rename/Rename.schema";
import {RenamePropsInterface} from "@/views/Admin/Events/Event/Promocodes/Rename/Rename.props.interface";

const Rename = ({data, onChange, onSubmit, onCancel}: RenamePropsInterface) => {
    const [form, setForm] = useState({
        ...RenameSchema, fields: FormFields(RenameSchema.fields).setKey('value', {name: data.name}).build()
    })
    const {name} = form.fields
    const [active, setActive] = useState(false);
    const toast = useToast()

    useEffect(() => {
        if (onSubmit) {
            setActive(true);
        }
    }, [onSubmit]);

    const handleChange = (field, value) => {
        setForm(prev => ({...prev, fields: {...prev.fields, [field]: {...prev.fields[field], value, error: null}}}))
    }

    const handleClose = () => {
        setActive(false);
        onCancel?.();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        handleDropErrors()
        setForm(prev => ({...prev, isLoading: true}))

        const payload: Record<string, string> = Object.fromEntries(
            Object.entries(
                FormFields(form.fields).getKeyValue()
            ).map(([k, v]) => [k, String(v ?? '')])
        );

        try {
            const response: any = await onSubmit?.({...payload, id: data.id})
            const {message, errors} = response.data
            if (response.data.data) {
                toast({type: 'success', message: message || 'Операция выполнена успешно'});
                setActive(false);
                handleClose()
                handleUpdate()
                return
            }
            if (errors) {
                setForm(prev => ({
                    ...prev,
                    fields: FormFields(form.fields)
                        .setKey(
                            'error',
                            Object.fromEntries(Object.entries(errors).map(([key, {detail}]) => ['name', detail])) as object
                        )
                        .build()
                }))
            }
        } catch (e) {
            toast({type: 'danger', message: e.message || 'Произошла ошибка. Повторите попытку позднее'});
        } finally {
            setForm(prev => ({...prev, isLoading: false}))
        }
    };

    const handleUpdate = () => {
        onChange(prev => ({
            ...prev,
            groups: {
                ...prev.groups,
                data: prev.groups.data.map(g => g.id === data.id
                    ? ({...g, name: form.fields.name.value as string})
                    : g
                )
            }
        }))
    }

    const handleDropErrors = () => {
        setForm(prev => ({...prev, fields: FormFields(form.fields).setKey('error', null).build()}))
    }

    return (
        <Modal
            className={styles.container}
            active={active}
            style={{maxWidth: 420}}
            onActive={setActive}
            onMissClick={handleClose}
            onEscape={handleClose}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.icon}><WarningIcon/></div>
                <div className={styles.content}>
                    <h6>
                        Редактирование группы
                    </h6>
                    <div className={styles.description}>
                        <Input
                            type={'email'}
                            value={name.value}
                            label={name.label}
                            placeholder={name.placeholder}
                            error={name.error}
                            disabled={form.isLoading || name.isDisabled}
                            onChange={({target}) => handleChange('name', target.value)}
                            size={"small"}
                        />
                    </div>
                    <div className={styles.btns}>
                        <Button
                            type={'tertiary'}
                            theme={'ghost'}
                            size={'small'}
                            htmlType={'reset'}
                            disabled={form.isLoading}
                            onClick={handleClose}>
                            Закрыть
                        </Button>
                        <Button
                            type={'primary'}
                            theme={'default'}
                            size={'small'}
                            htmlType={'submit'}
                            disabled={form.isLoading}
                            onClick={handleSubmit}>
                            Сохранить
                        </Button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default Rename;
